<template>
  <recent-actions :recent-actions="recentActions"
                  :get-action-text="getRecentActionText"
                  background-color="#f6f6f6" />
</template>

<script>
import RecentActions from '../../campaign-action-shared/recent-actions'

export default {
  components: { RecentActions },

  props: {
    recentActions: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      getRecentActionText: (recentAction) => {
        const { name } = recentAction
        return this.i18n.t('petitions.view.recent_signatures.signed', {name})
      }
    }
  }
}
</script>
